import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Compass, Timer, Layers } from 'lucide-react';
export function MechanismSection() {
  const steps = [{
    icon: Compass,
    title: 'Mapa 3AM (5 disparadores)',
    desc: 'Dejas de probar cosas al azar. Identificas exactamente qué te despertó.'
  }, {
    icon: Timer,
    title: 'Reset de 12 minutos (sin pantallas)',
    desc: 'Un protocolo exacto para bajar la activación: respiración + micro-movimiento + temperatura + guion anti-pánico.'
  }, {
    icon: Layers,
    title: 'Plan por etapas (5/15/30/60)',
    desc: 'Porque una cosa es despertarte 5 minutos… y otra es llevar 45 y estar pensando que tu vida se arruinó.'
  }];
  return <section className="py-24 px-4 bg-[var(--bg-primary)]" data-id="element-86">
      <div className="max-w-3xl mx-auto" data-id="element-87">
        <SectionWrapper data-id="element-88">
          <h2 className="text-3xl md:text-5xl text-[var(--text-primary)] mb-4 text-center" data-id="element-89">
            El mecanismo
          </h2>
          <p className="text-xl text-[var(--text-secondary)] text-center mb-16 font-serif italic" data-id="element-90">
            Lo que haces cuando abres los ojos
          </p>
        </SectionWrapper>

        <div className="space-y-8" data-id="element-91">
          {steps.map((step, index) => <SectionWrapper key={index} delay={0.2 + index * 0.15} data-id="element-92">
              <div className="flex flex-col md:flex-row gap-6 bg-[var(--bg-card)] p-8 rounded-2xl border border-[var(--bg-card-hover)]" data-id="element-93">
                <div className="shrink-0 flex items-center justify-center w-16 h-16 rounded-full bg-[var(--bg-deepest)] border border-[var(--bg-card-hover)] text-[var(--accent-amber)]" data-id="element-94">
                  <step.icon className="w-8 h-8" data-id="element-95" />
                </div>
                <div data-id="element-96">
                  <div className="flex items-center gap-3 mb-2" data-id="element-97">
                    <span className="text-xs font-bold px-2 py-1 rounded bg-[var(--accent-amber)] text-[var(--bg-deepest)]" data-id="element-98">
                      PASO {index + 1}
                    </span>
                    <h3 className="text-xl md:text-2xl font-bold text-[var(--text-primary)]" data-id="element-99">
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-lg text-[var(--text-secondary)] leading-relaxed" data-id="element-100">
                    {step.desc}
                  </p>
                </div>
              </div>
            </SectionWrapper>)}
        </div>

        <SectionWrapper delay={0.6} data-id="element-101">
          <div className="mt-16 text-center" data-id="element-102">
            <p className="text-2xl md:text-3xl font-serif text-[var(--text-primary)] mb-2" data-id="element-103">
              Tú no vas a improvisar.
            </p>
            <p className="text-2xl md:text-3xl font-serif text-[var(--accent-teal)] italic" data-id="element-104">
              Vas a seguir un plan.
            </p>
          </div>
        </SectionWrapper>
      </div>
    </section>;
}